//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {api_CasebattleRoomHistory , api_MemberCasebattleHistory} from "../../../api";
	import {conversion} from "../../../tool";
	import { mapState, mapMutations } from 'vuex';

	export default {
		data(){
		    return {
				tabId: 0,
				historyData: {
					data: { list: [] },
					current: 1,
					size: 15
				},
            }
        },
		beforeRouteLeave(to, from, next) {
			if (this.$caseBattleHub.isBattleRoute(to)) {
				next();
				return;
			}

			this.$caseBattleHub.stopHub().then(next).catch(next);
		},
		computed: {
			...mapState(["user"]),
		},		
        methods: {		
			...mapMutations([
			"setloginModal"]),

			goToBattleDetail(item){
				this.$router.push({name:'battleDetail' ,params:{ id: item.id}, query: this.$route.query || {} });
			},
			switchTab(id){

				if(id == 1 && !this.user.id ){
					return this.setloginModal(true);
				}
				this.tabId = id;
				this.historyData.current = 1;
				this.getList({ page: 1, size: this.historyData.size });

			},
			//翻页接口
			async getList(obj) {

				var getDataApi = this.tabId == 0? api_CasebattleRoomHistory: api_MemberCasebattleHistory;

				getDataApi(obj).then(res => {
					if (res.data.code === 0) {
						this.historyData.data.list = res.data.data.data;
						this.historyData.data.total = res.data.data.totalItems;

						if(this.historyData.data.total > 450){
							this.historyData.data.total = 450;
						}	


						this.historyData.data.list .forEach((item) => {

							item.statusTemp = item.roomState === 0 ? '等待中' : '进行中';

							if(item.roomState == 1){
								var totalRoundTime = item.cases.length * 4000 ;
								var ms_over = new Date().getTime() - new Date(item.updatedTime.replace(/\-/g,"/")).getTime();

								if(ms_over > totalRoundTime){
									item.statusTemp  = "已结束";
								}
							}
						});
					}
				});
			},
			//翻页
			pageF(v) {
				this.getList({ page: v, size: this.historyData.size });
			},
        },
        filters: {
			conversion,
			add(v) {
				return v > 0 ? `+${v}` : v;
			}
        },
        created() {
			this.getList({
				page: this.historyData.current,
				size: this.historyData.size
			});
		},
		name: "historyHistory"
	}
